// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1-_NO","overflowing":"ReadFullNote_overflowing__2tgzb"};